import Amplify, { API, graphqlOperation } from 'aws-amplify';
import { NoSql } from '../queries';

export const setNotificationIsReaded = async ({ notificationId }) => {
  Amplify.configure({
    API: {
      graphql_endpoint: process.env.REACT_APP_API_URL_NO_SQL,
    },
  });
  const result = await API.graphql(
    graphqlOperation(NoSql.Notifications.updateNotifications(), {
      data: {
        isReaded: { set: true },
      },
      where: {
        id: notificationId,
      },
    })
  )
    .then((result) => result)
    .catch((e) => {
      console.log(
        '🚀 ~ file: NoSqlUtils.js:248 ~ getManyNotifications ~ e:',
        e
      );
      return e;
    });
  Amplify.configure({
    API: {
      graphql_endpoint: process.env.REACT_APP_API_URL,
    },
  });
  return result;
};

export const getCountOfNotifications = async ({ where }) => {
  Amplify.configure({
    API: {
      graphql_endpoint: process.env.REACT_APP_API_URL_NO_SQL,
    },
  });
  const result = await API.graphql(
    graphqlOperation(NoSql.Notifications.notificationsCount(), {
      where,
    })
  )
    .then((result) => result)
    .catch((e) => {
      console.log(
        '🚀 ~ file: NoSqlUtils.js:248 ~ getManyNotifications ~ e:',
        e
      );
      return e;
    });
  Amplify.configure({
    API: {
      graphql_endpoint: process.env.REACT_APP_API_URL,
    },
  });
  return result;
};

export const getManyNotifications = async ({
  where,
  take,
  skip,
  orderBy = { id: 'desc' },
}) => {
  Amplify.configure({
    API: {
      graphql_endpoint: process.env.REACT_APP_API_URL_NO_SQL,
    },
  });
  const result = await API.graphql(
    graphqlOperation(
      NoSql.Notifications.findManyNotificationReceiversByUserId(),
      {
        where,
        take,
        skip,
        orderBy,
      }
    )
  )
    .then((result) => result)
    .catch((e) => {
      console.log(
        '🚀 ~ file: NoSqlUtils.js:248 ~ getManyNotifications ~ e:',
        e
      );
      return e;
    });
  Amplify.configure({
    API: {
      graphql_endpoint: process.env.REACT_APP_API_URL,
    },
  });
  return result;
};

const runNoSqlGraphql = async ({ document, variables, logLabel }) => {
  Amplify.configure({
    API: {
      graphql_endpoint: process.env.REACT_APP_API_URL_NO_SQL,
    },
  });
  const result = await API.graphql(graphqlOperation(document, variables))
    .then((result) => result)
    .catch((e) => {
      console.log(`🚀 ~ file: NoSqlUtils.js ~ ${logLabel} ~ e:`, e);
      return e;
    });
  Amplify.configure({
    API: {
      graphql_endpoint: process.env.REACT_APP_API_URL,
    },
  });
  return result;
};

export const getManyAssistantConversations = async ({
  where,
  take,
  skip,
  orderBy = { updatedAt: 'desc' },
}) =>
  runNoSqlGraphql({
    document: NoSql.AssistantConversation.findManyAssistantConversations(),
    variables: { where, take, skip, orderBy },
    logLabel: 'getManyAssistantConversations',
  });

export const getCountOfAssistantConversations = async ({ where }) =>
  runNoSqlGraphql({
    document: NoSql.AssistantConversation.assistantConversationsCount(),
    variables: { where },
    logLabel: 'getCountOfAssistantConversations',
  });

export const getAssistantConversationUserGroups = async ({ where } = {}) =>
  runNoSqlGraphql({
    document: NoSql.AssistantConversation.groupByAssistantConversationUsers(),
    variables: { where, by: ['userId'] },
    logLabel: 'getAssistantConversationUserGroups',
  });

export const getAssistantConversation = async ({ id }) =>
  runNoSqlGraphql({
    document: NoSql.AssistantConversation.findAssistantConversationById(),
    variables: { where: { id } },
    logLabel: 'getAssistantConversation',
  });

export const updateAssistantConversation = async ({ id, data }) =>
  runNoSqlGraphql({
    document: NoSql.AssistantConversation.updateAssistantConversation(),
    variables: { where: { id }, data },
    logLabel: 'updateAssistantConversation',
  });

export const deleteAssistantConversation = async ({ id }) =>
  runNoSqlGraphql({
    document: NoSql.AssistantConversation.deleteAssistantConversation(),
    variables: { where: { id } },
    logLabel: 'deleteAssistantConversation',
  });
